import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/map.png'
import _imports_1 from '@/assets/images/location-icon.png'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "join-contact-form-section" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = {
  class: "form-tabs--btm tab-content",
  id: "myTabContent"
}
const _hoisted_6 = {
  class: "tab-pane fade show active",
  id: "taba",
  role: "tabpanel",
  "aria-labelledby": "tab-a"
}
const _hoisted_7 = { class: "contact-form" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-4" }
const _hoisted_10 = { class: "input-field" }
const _hoisted_11 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_12 = { class: "col-sm-4" }
const _hoisted_13 = { class: "input-field" }
const _hoisted_14 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_15 = { class: "col-sm-4" }
const _hoisted_16 = { class: "input-field" }
const _hoisted_17 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_18 = { class: "col-sm-12" }
const _hoisted_19 = { class: "input-field" }
const _hoisted_20 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_21 = { class: "col-sm-12" }
const _hoisted_22 = { class: "input-submit" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  class: "tab-pane fade",
  id: "tabb",
  role: "tabpanel",
  "aria-labelledby": "tab-b"
}
const _hoisted_25 = { class: "joinus-form" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-sm-4" }
const _hoisted_28 = { class: "input-field" }
const _hoisted_29 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_30 = { class: "col-sm-4" }
const _hoisted_31 = { class: "input-field" }
const _hoisted_32 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_33 = { class: "col-sm-4" }
const _hoisted_34 = { class: "input-field" }
const _hoisted_35 = ["value"]
const _hoisted_36 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_37 = { class: "col-sm-4" }
const _hoisted_38 = { class: "input-field" }
const _hoisted_39 = { class: "col-sm-4" }
const _hoisted_40 = { class: "input-field" }
const _hoisted_41 = { class: "browse-input" }
const _hoisted_42 = { class: "browse-field" }
const _hoisted_43 = {
  key: 0,
  class: "browsed-img"
}
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "col-sm-4" }
const _hoisted_46 = { class: "input-field" }
const _hoisted_47 = { class: "browse-input" }
const _hoisted_48 = { class: "browse-field" }
const _hoisted_49 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_50 = {
  key: 1,
  class: "custom-progress-bar"
}
const _hoisted_51 = { class: "custom-progress-bar-left" }
const _hoisted_52 = { class: "custom-progress-bar-right" }
const _hoisted_53 = {
  key: 0,
  class: "browsed-img"
}
const _hoisted_54 = { class: "col-sm-12" }
const _hoisted_55 = { class: "input-field" }
const _hoisted_56 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_57 = { class: "col-sm-12" }
const _hoisted_58 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_59 = { class: "col-sm-12" }
const _hoisted_60 = { class: "input-submit" }
const _hoisted_61 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_userFooter = _resolveComponent("userFooter")!
  const _component_ChatbotPopup = _resolveComponent("ChatbotPopup")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", {
        class: "page-banner-section",
        style: _normalizeStyle({ 'background-image': `url(${require('@/assets/images/about-banner-img.jpg')})` })
      }, [...(_cache[15] || (_cache[15] = [
        _createElementVNode("div", { class: "container" }, [
          _createElementVNode("h1", null, "About LMD Consulting")
        ], -1)
      ]))], 4),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "form-tabs--top" }, [
            _createElementVNode("ul", {
              class: "nav",
              id: "myTab",
              role: "tablist"
            }, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "active",
                  id: "tab-a",
                  "data-bs-toggle": "tab",
                  href: "#taba",
                  role: "tab",
                  "aria-controls": "taba",
                  "aria-selected": "true"
                }, "Contact Us")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  id: "tab-b",
                  "data-bs-toggle": "tab",
                  href: "#tabb",
                  role: "tab",
                  "aria-controls": "tabb",
                  "aria-selected": "false"
                }, "Join Our Team")
              ])
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitContactUs && _ctx.submitContactUs(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: " Name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactUsForm.name) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.contactUsForm.name]
                        ]),
                        (_ctx.contactUsErrors.name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.contactUsErrors.name), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          placeholder: " Email",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contactUsForm.email) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.contactUsForm.email]
                        ]),
                        (_ctx.contactUsErrors.email)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.contactUsErrors.email), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: " Subject",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contactUsForm.subject) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.contactUsForm.subject]
                        ]),
                        (_ctx.contactUsErrors.subject)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.contactUsErrors.subject), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _withDirectives(_createElementVNode("textarea", {
                          placeholder: " Message",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contactUsForm.message) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.contactUsForm.message]
                        ]),
                        (_ctx.contactUsErrors.message)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.contactUsErrors.message), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("button", {
                          class: "primary-btn-outline",
                          disabled: _ctx.isSubmitting
                        }, _toDisplayString(_ctx.isSubmitting ? 'Submitting...' : 'Submit'), 9, _hoisted_23),
                        _createElementVNode("button", {
                          type: "button",
                          class: "primary-btn-outline",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetContactUsForm && _ctx.resetContactUsForm(...args)))
                        }, "Reset")
                      ])
                    ])
                  ])
                ], 32)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("form", {
                onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitApplication && _ctx.submitApplication(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: " Name",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.applicationForm.candidateName) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.applicationForm.candidateName]
                        ]),
                        (_ctx.applicationErrors.candidateName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.applicationErrors.candidateName), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          placeholder: "Email Address*",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.applicationForm.email) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.applicationForm.email]
                        ]),
                        (_ctx.applicationErrors.email)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.applicationErrors.email), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _withDirectives(_createElementVNode("select", {
                          class: "selectbox",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.applicationForm.designation) = $event))
                        }, [
                          _cache[16] || (_cache[16] = _createElementVNode("option", { value: "" }, "Select Job", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobCategories, (category) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: category.id,
                              value: category.title
                            }, _toDisplayString(category.title), 9, _hoisted_35))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.applicationForm.designation]
                        ]),
                        (_ctx.applicationErrors.designation)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.applicationErrors.designation), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "Name of your Reference (if any)",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.applicationForm.nameOfReference) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.applicationForm.nameOfReference]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "browse-button company-logo" }, "Upload Image", -1)),
                            (_openBlock(), _createElementBlock("input", {
                              type: "file",
                              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleFileUpload($event))),
                              accept: "image/jpeg,image/jpg,image/png",
                              key: _ctx.fileInputKey
                            }, null, 32))
                          ]),
                          (_ctx.imageUploaded)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                _createElementVNode("img", {
                                  src: _ctx.imageUrl,
                                  alt: ""
                                }, null, 8, _hoisted_44)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "browse-button company-logo" }, "Upload Resume", -1)),
                            (_openBlock(), _createElementBlock("input", {
                              type: "file",
                              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleResumeUpload($event))),
                              accept: ".pdf, .docx",
                              key: _ctx.fileInputKey
                            }, null, 32)),
                            (!_ctx.selectedResumeFile && _ctx.applicationErrors.candidateResume)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.applicationErrors.candidateResume), 1))
                              : _createCommentVNode("", true),
                            (_ctx.uploadProgress > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("span", {
                                      style: _normalizeStyle(`width:${_ctx.uploadProgress}%`)
                                    }, null, 4)
                                  ]),
                                  _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.uploadProgress) + "%", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.resumeUploaded)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.ResumeName), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _withDirectives(_createElementVNode("textarea", {
                          placeholder: "Details",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.applicationForm.description) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.applicationForm.description]
                        ]),
                        (!_ctx.applicationForm.description)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.errMsg), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", {
                        id: "aboutUsCaptchaWidget",
                        class: "g-recaptcha"
                      }, null, -1)),
                      (_ctx.recaptchaError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.recaptchaError), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("button", {
                          class: "primary-btn-outline",
                          disabled: _ctx.isSubmitting
                        }, _toDisplayString(_ctx.isSubmitting ? 'Submitting...' : 'Submit'), 9, _hoisted_61),
                        _createElementVNode("button", {
                          type: "button",
                          class: "primary-btn-outline",
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                        }, "Reset")
                      ])
                    ])
                  ])
                ])
              ], 32)
            ])
          ])
        ])
      ]),
      _cache[21] || (_cache[21] = _createStaticVNode("<section class=\"our-location-section\"><div class=\"container\"><h2>Our Locations</h2><div class=\"location-map\"><img src=\"" + _imports_0 + "\" alt=\"world-map\" class=\"world-map\"><div class=\"address-bg usa\"><div class=\"address\"><ul><li><i class=\"fa fa-home\"></i> <span>21515 Ridgetop Circle Suite 150 Sterling, VA 20166</span></li><li><i class=\"fa fa-phone\"></i> <span>+1 571-313-8814</span></li><li><i class=\"fa fa-envelope\"></i> <span><a href=\"mailto:hello@lmdconsulting.com\">hello@lmdconsulting.com</a></span></li></ul><img src=\"" + _imports_1 + "\" class=\"map-icon\"></div></div><div class=\"address-bg india\"><div class=\"address\"><ul><li><i class=\"fa fa-home\"></i> <span>2nd Floor, Plot No. B-2/19, Gandhipath, Chitrakoot, Jaipur, Rajasthan 302021</span></li><li><i class=\"fa fa-phone\"></i> <span>+91 141-491-5291</span></li><li><i class=\"fa fa-envelope\"></i> <span><a href=\"mailto:hello@lmdconsulting.com\">hello@lmdconsulting.com</a></span></li></ul><img src=\"" + _imports_1 + "\" class=\"map-icon\"></div></div></div></div></section>", 1))
    ]),
    _createVNode(_component_userFooter),
    _createVNode(_component_ChatbotPopup, { ref: "chatbotPopup" }, null, 512)
  ]))
}